// extracted by mini-css-extract-plugin
export var cartContainer = "_pg-4";
export var gray = "_pg-1";
export var itemContainer = "_pg-2";
export var itemDetails = "_pg-3";
export var strong = "_pg-0";